import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { AssignmentExchangeModel } from '../../../models/assignment-exchange.model';
import { AssignmentsOverviewModel } from '../../../models/assignments-overview.model';
import { AssignmentDetailsModel } from '../models/assignment-details.model';

@Injectable({
    providedIn: 'root',
})
export class AssignmentsHelperService {

    constructor(private httpClient: HttpClient) { }

    transformOverviewModelsToExchangeModel(overviewModels: AssignmentsOverviewModel[]): AssignmentExchangeModel[] {
        return overviewModels.map(x => {
            return this.transformOverviewModelToExchangeModel(x);
        });
    }

    transformOverviewModelToExchangeModel(overviewModel: AssignmentsOverviewModel): AssignmentExchangeModel {
        let exchangeModel: AssignmentExchangeModel = {
            assignmentId: overviewModel.id as number,
            sportId: overviewModel.sportId,
            sportName: overviewModel.sportName,
            number: overviewModel.number,
            title: overviewModel.title,
            location: overviewModel.location,
            from: overviewModel.from,
            to: overviewModel.to,
            isSuccess: null,
            errorMessage: null
        };

        return exchangeModel;
    }


    transformDetailsToExchangeModel(detailsModel: AssignmentDetailsModel): AssignmentExchangeModel {
        let exchangeModel: AssignmentExchangeModel = {
            assignmentId: detailsModel.id,
            sportId: detailsModel.sportId,
            sportName: detailsModel.sportName,
            number: detailsModel.number,
            title: detailsModel.title,
            location: detailsModel.location ?? detailsModel.locations[0]?.room,
            from: detailsModel.from,
            to: detailsModel.to,
            isSuccess: null,
            errorMessage: null
        };

        return exchangeModel;
    }
}
